import React from 'react'
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import deixarReservasEmAberto from '../../actions/reserva/deixarReservasEmAberto';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalConfirmacaoReservaEmAberto extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoReservasEmAberto')
      .modal('hide');
    $('#modalConfirmacaoReservasEmAberto')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.props.deixarReservasEmAberto(this.props.empresaSelecionada.id, values.observacao, this.props.reservas.filter(f => f.selecionada)
      .map(it => it.id))
      .then(() => {
          showSuccessMsg('Reservas estão em aberto');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirReservas () {
    return <div className='mt-4 ml-2'>
      Reservas:
      <ul>
        {this.props.reservas.filter(f => f.selecionada)
          .map(reserva => <React.Fragment key={reserva.id}>
            <li>{reserva.descCidadeOrigem} -&gt; {reserva.descCidadeDestino}: {reserva.passageiroDto.nome}</li>
          </React.Fragment>)}
      </ul>
    </div>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoReservasEmAberto" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoReservasEmAberto" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada)
                  ?
                  <React.Fragment>
                    {this.exibirReservas()}
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea} validate={[required]} className="form-control" label="Motivo da alteração:"/>
                  </React.Fragment>
                  : ''}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  deixarReservasEmAberto
})(reduxForm({
  form: 'formularioReservaEmAberto',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoReservaEmAberto));
